export function scrollToId(id: string) {
    const node = document.getElementById(id);
    if (!node) return;

    if (id === "top") {
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
    }

    const headerOffset = 96;
    const targetTop = node.getBoundingClientRect().top + window.scrollY - headerOffset;

    window.scrollTo({
        top: Math.max(targetTop, 0),
        behavior: "smooth",
    });
}
